.main-container {
  display: inline-block;
  border-radius: 4px;
  overflow: hidden;
  width: calc(100% - 8px);
  margin: 0 4px;
  background-color: $light-grey-lighten5;
}

.game-tile {
  width: 60px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #232323;

  .button.casino {
    background-color: transparent;
    height: 100%;
    width: 100%;
    padding: 6px 8px;
    justify-content: space-between;
  }

  .button.close {
    background-color: transparent;
  }

  div {
    display: flex;
    align-items: center;

    .casino-icon {
      path {
        transform: scale(0.5);
      }
    }

    div {
      span {
        color: $light-grey-lighten5;
        font-size: 15px;
        font-family: Arial, sans-serif;
        font-weight: bold;
      }
    }
  }

  .bottom-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background-color: #0075c6;
  }
}

.body {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  flex-wrap: nowrap;
  padding: 4px;
  background-color: $light-grey-lighten5;
  user-select: none;
  cursor: grab;
  gap: 4px;
  align-items: center;

  loading-spinner {
    margin: 0 auto;
  }
}

@media screen and (min-width: 960px) {
  .header {
    .button.casino {
      background-color: transparent;
      height: 100%;
      width: 100%;
      padding: 8px;
      justify-content: space-between;
    }

    div {
      width: 100%;

      div {
        width: 100%;
        justify-content: space-between;

        span {
          margin-left: 8px;
        }
      }
    }
  }

  .body:not(.betslip-mode-body) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    -ms-overflow-style: none;
    /* for Internet Explorer, Edge */
    scrollbar-width: none;
    /* for Firefox */

    &::-webkit-scrollbar {
      display: none;
      /* for Chrome, Safari, and Opera */
    }

    casino-mini-widget-game-tile {
      .game-tile {
        width: 100% !important;
      }
    }
  }

  .game-tile {
    width: 84px;

    .play-overlay {
      .button.play {
        min-width: 70px;
      }
    }
  }
}
